/**
 * Интеграция с Sentry — отключаемая через ENV.
 * Если VITE_SENTRY_ENABLED !== 'true', SDK не загружается (zero overhead).
 */

let sentryEnabled = false;

/** Ссылка на модуль Sentry после динамического импорта */
let SentryModule: typeof import('@sentry/react') | null = null;

/**
 * Инициализация Sentry.
 * Вызывать перед ReactDOM.createRoot в main.tsx.
 */
export async function initSentry(): Promise<void> {
	if (import.meta.env.VITE_SENTRY_ENABLED !== 'true') {
		return;
	}

	try {
		const Sentry = await import('@sentry/react');
		Sentry.init({
			dsn: import.meta.env.VITE_SENTRY_DSN,
			environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'production',
			tracesSampleRate: 0.1,
		});
		SentryModule = Sentry;
		sentryEnabled = true;
	} catch {
		// Sentry SDK загрузить не удалось — продолжаем без него
		console.warn('Sentry SDK failed to load, continuing without error tracking');
	}
}

/**
 * Отправка ошибки в Sentry (если включён).
 * Безопасно вызывать даже при отключённом Sentry.
 */
export function captureException(error: unknown): void {
	if (!sentryEnabled || !SentryModule) {
		return;
	}
	SentryModule.captureException(error);
}
